<template>
  <div class="showroom-invite-mail-preview">
    <el-form label-width="120px">
      <el-form-item label="Subject">
        <pre>{{ realSubject }}</pre>
      </el-form-item>
      <el-form-item label="Message body">
        <pre>{{ realBody }}</pre>
      </el-form-item>
      <el-form-item label="Reply-To">
        <pre>{{ replyTo || '-' }}</pre>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useStore } from '@/store'

export default {
  props: {
    subject: { type: String, default: '' },
    body: { type: String, default: '' },
    replyTo: { type: String, default: '' },
  },
  setup(props) {
    const store = useStore()

    const mapping = {
      COMPANY_NAME: store.state.eventDetails.event.organization.name,
      SHOWROOM_NAME: store.state.eventDetails.event.name,
      ACTIVATION_LINK: '{{ ACTIVATION LINK WOULD BE SHOWN HERE }}',
    }
    const transformText = (text) => {
      let transformedText = text
      Object.entries(mapping).forEach(([key, val]) => {
        transformedText = transformedText.replace(key, val)
      })
      return transformedText
    }
    const realSubject = computed(() => {
      return transformText(props.subject)
    })
    const realBody = computed(() => {
      return transformText(props.body)
    })

    return {
      realSubject,
      realBody,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.showroom-invite-mail-editor {
  color: $grey90;

  .el-form-item__content {
    .hint {
      color: $grey120;
    }
  }

  pre {
    white-space: pre-wrap; /* css-3 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: keep-all;
  }
}
</style>
